import React, { useState } from "react";

import {
    Box,
    Flex,
    Text,
    Switch,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";
import { useCustomNotification } from "components/Toasts/OpenNotification";

import {
    createCommissionConfigurationAction,
} from "state/actions/agentCommissionActions";

import { useDispatch } from "react-redux";

const AddCommissionConfiguration = ({
    isOpen,
    onClose,
}) => {
    const dispatch = useDispatch();
    const notify = useCustomNotification();

    const [
        commissionPercentage,
        setCommissionPercentage,
    ] = useState("");

    const [
        isActive,
        setIsActive,
    ] = useState(true);

    const [
        loading,
        setLoading,
    ] = useState(false);

    const handleSubmit = async () => {
        const percentage = Number(
            commissionPercentage
        );

        if (
            commissionPercentage === "" ||
            Number.isNaN(percentage)
        ) {
            notify({
                message:
                    "Enter a valid commission percentage.",
                type: "error",
            });

            return;
        }

        if (
            percentage < 0 ||
            percentage > 100
        ) {
            notify({
                message:
                    "Commission percentage must be between 0 and 100.",
                type: "error",
            });

            return;
        }

        setLoading(true);

        try {
            const response = await dispatch(
                createCommissionConfigurationAction({
                    commission_percentage:
                        percentage,
                    is_active: isActive,
                })
            );

            if (response?.success) {
                notify({
                    message:
                        "Commission configuration created successfully.",
                    type: "success",
                });

                setCommissionPercentage("");
                setIsActive(true);

                onClose();
            } else {
                notify({
                    message:
                        response?.error ||
                        "Failed to create commission configuration.",
                    type: "error",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            headerContent={
                <Text
                    fontSize="lg"
                    fontWeight="bold"
                >
                    Add Commission Configuration
                </Text>
            }
            bodyContent={
                <Box p={4}>
                    <Box mb={6}>
                        <Text
                            fontSize="md"
                            fontWeight="500"
                            color="gray.500"
                            mb={4}
                        >
                            Commission Details
                        </Text>

                        <ReusableInput
                            label="Commission Percentage"
                            type="number"
                            value={
                                commissionPercentage
                            }
                            onChange={(e) =>
                                setCommissionPercentage(
                                    e.target.value
                                )
                            }
                            placeholder="e.g. 7"
                        />
                    </Box>

                    <Flex
                        alignItems="center"
                        justifyContent="space-between"
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="xl"
                        p={4}
                        mb={6}
                    >
                        <Box>
                            <Text
                                fontWeight="600"
                                color="gray.800"
                            >
                                Active Configuration
                            </Text>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                                mt={1}
                            >
                                Enable this commission
                                configuration.
                            </Text>
                        </Box>

                        <Switch
                            isChecked={isActive}
                            onChange={(e) =>
                                setIsActive(
                                    e.target.checked
                                )
                            }
                            size="md"
                        />
                    </Flex>

                    <Flex
                        justifyContent="flex-end"
                        gap={3}
                    >
                        <GradientButton
                            onClick={onClose}
                            variant="outline"
                              height="30px"
                        >
                            Cancel
                        </GradientButton>

                        <GradientButton
                            onClick={handleSubmit}
                            isLoading={loading}
                              height="30px"
                        >
                            Create Configuration
                        </GradientButton>
                    </Flex>
                </Box>
            }
        />
    );
};

export default AddCommissionConfiguration;